var _onFontsLoaded = {
	callbacks: {},
	do: function() {
		var callbacks = this.callbacks;
		$.each(callbacks, function(i, callback) {
			callback();
		});
	}
};

(function() {

	var html = document.documentElement;
	var ffoScript = document.createElement('script');

	var params = {
		ffoPath: '/_assets/dist/js/lib/fontfaceobserver.js',
		expirationDays: 30,
		cookieName: 'fonts-loaded',
		loadedClass: 'js-fonts-loaded'
	};

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `load_ffo_asynchronously`
	 *
	 * Loads the font-face observer asynchronously.
	 */
	function load_ffo_asynchronously() {
		ffoScript.src = params.ffoPath;
		ffoScript.async = true;
		document.head.appendChild(ffoScript);
	}

	/**
	 * @function `setCookie`
	 *
	 * Set a cookie for a defined period of time.
	 */
	function setCookie() {
		var d = new Date();
		d.setTime(d.getTime() + (params.expirationDays * 24 * 60 * 60 * 1000));
		var expirationDate = d.toUTCString();
		document.cookie = params.cookieName+'=true;expires='+expirationDate;
	}

	function applyWebfonts() {
		html.classList.add(params.loadedClass);
	}

	/**
	 * @function `loadFonts`
	 *
	 * Loads the fonts asynchronously and shows them once they have all loaded.
	 * After that, the cookie is set.
	 *
	 * 1. If the cookie exists, webfonts are applied directly.
	 */
	function loadFonts() {
		if( html.className.indexOf(params.loadedClass) > -1 ){
			return; /* [1] */
		}
		var lettera = new FontFaceObserver("Lettera Text");
		var modern = new FontFaceObserver("Modern No 20");
		Promise.all([
			lettera.load(),
			modern.load()
		]).then(function(){
			_onFontsLoaded.do();
		}, function() {
			// Fonts unavailable
		});
	}

	//	======================================================================  //
	//	ASAP
	//	======================================================================  //

	load_ffo_asynchronously();

	//	======================================================================  //
	//	When FFO has loaded
	//	======================================================================  //

	ffoScript.onload = loadFonts;
	_onFontsLoaded.callbacks.applyWebfonts = applyWebfonts;
	_onFontsLoaded.callbacks.setCookie = setCookie;

})();
